import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Modal from "./Modal";
import { Button } from "./Button";

const GlobalMessageModal = () => {
  const [globalModalMessageState, setGlobalModalMessageState] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const globalModalMessage = searchParams.get("globalModalMessage");

  useEffect(() => {
    if (globalModalMessage) {
      setGlobalModalMessageState(globalModalMessage);
    }
  }, [globalModalMessage, searchParams, setSearchParams]);

  return (
    <>
      {globalModalMessageState ? (
        <Modal
          title=""
          setIsModalVisible={() => {
            setGlobalModalMessageState("");
            searchParams.delete("globalModalMessage");
            setSearchParams(searchParams);
          }}
        >
          <>
            <div className="w-[calc(100vw-20vw)] bg-blue-500 max-w-[22rem] flex justify-start mb-[1.8125rem]"></div>

            <div className="w-full max-w-[22rem] flex flex-col items-center mb-[29px]">
              {globalModalMessage}
            </div>
            <div className="flex flex-row gap-[10px]">
              <Button
                variant="primary"
                type="submit"
                loading={false}
                onClick={() => {
                  setGlobalModalMessageState("");
                  searchParams.delete("globalModalMessage");
                  setSearchParams(searchParams);
                }}
                className="w-full h-[50px]"
              >
                확인
              </Button>
            </div>
          </>
        </Modal>
      ) : null}
    </>
  );
};

export default GlobalMessageModal;
